import { render, staticRenderFns } from "./FeeFailedModal.vue?vue&type=template&id=7f8d8e10&"
import script from "./FeeFailedModal.vue?vue&type=script&lang=js&"
export * from "./FeeFailedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports